window.addEventListener('load', function () {
     setTimeout(function() {
        document.getElementById('header').style.pointerEvents = 'auto';
        console.log('sssaaas');
    }, 3000); // 4000 milliseconds = 4 seconds
});


// Detect iOS (iPhone / iPod / iPad in Safari)
var isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) {
  const observer = new MutationObserver((mutations) => {
    if (document.body.matches('[data-brl-payment-scroll-lock], [data-brl-menu-scroll-lock]')) return;
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        if (document.body.style.overflow === 'hidden') {
          setTimeout(function() {
            if (!document.body.matches('[data-brl-payment-scroll-lock], [data-brl-menu-scroll-lock]') && document.body.style.overflow === 'hidden' && document.body.style.position !== 'fixed') document.body.style.position = 'fixed';
          }, 100);
        } else if (document.body.style.position !== '') {
          document.body.style.position = '';
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
}